/**
 * 処理後物
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const search_recycle_disposed_item = {
  namespaced: true,
  state: () => ({}),
  getters: {},
  actions: {
    /**
     * 処理後物一覧取得
     */
    index () {
      return new Promise((resolve) => {
        Vue.$http.get(`${httpConst.DRIVER_ENDPOINT}/masters/search/recycle_disposed_items`).then(data => {
          const content = data.content;
          resolve(content)
        })
      })
    },
  },
  mutations: {
  },
}

export default search_recycle_disposed_item
